import { updateWebsite } from '@va/dashboard/actions/api';
import { getUrlViewFlag, getWebsiteFrontendFlags } from '@va/dashboard/selectors/core';
import { useAddNotification } from '@va/dashboard/util-hooks';
import { useTranslate } from '@va/localization';
import { URL_VIEW } from '@va/types/website';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateUrlView } from '../apiClient';

const useUrlAppearanceCard = () => {
  const websiteUrlViewFlag = useSelector(getUrlViewFlag);
  const frontendFlags = useSelector(getWebsiteFrontendFlags);

  const currentUrlView = useMemo(() => websiteUrlViewFlag, [websiteUrlViewFlag]);
  const [selectedUrlView, setSelectedUrlView] = useState(currentUrlView);

  const translate = useTranslate();
  const dispatch = useDispatch();
  const { showSuccessNotification, showErrorNotification } = useAddNotification();

  const { execute: updateUrlView, error, isSucceeded, clearError } = useUpdateUrlView();

  const onChange = (value: URL_VIEW) => {
    setSelectedUrlView(value);
    updateUrlView(value);
  };

  useEffect(() => {
    setSelectedUrlView(currentUrlView);
  }, [currentUrlView]);

  // Update local website state when api call is succeeded
  useEffect(() => {
    if (!isSucceeded) return;
    showSuccessNotification(2000);
    dispatch(
      updateWebsite({
        frontendFlags: {
          ...frontendFlags,
          urlView: selectedUrlView,
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isSucceeded, selectedUrlView, translate]);

  // Show error notification and change to previous state
  useEffect(() => {
    if (!error) return;
    clearError();
    showErrorNotification(2000);
    setSelectedUrlView(currentUrlView);
  }, [error, clearError, currentUrlView, showErrorNotification]);

  return {
    onChange,
    selectedUrlView,
  };
};

export default useUrlAppearanceCard;
